/* "Real People. Real Results." reviews carousel (spec 03b, 06 f). .vp is the scroller (native horizontal scroll-snap:
   touch swipe, trackpad), plus mouse drag on desktop, arrows that scroll one card + gap, a progress bar at
   (index+1)/count and ArrowLeft/ArrowRight on the focused scroller. No autoplay, no loop. The card list is read from the
   DOM (one card per block), so adding or removing a block changes the count and the progress math. */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.dataset.smRrReady) return;
    const vp = root.querySelector('[data-sm-reviews-scroller]');
    const track = vp && vp.firstElementChild;
    if (!vp || !track) return;
    root.dataset.smRrReady = '1';
    const prev = root.querySelector('[data-sm-reviews-prev]');
    const next = root.querySelector('[data-sm-reviews-next]');
    const fill = root.querySelector('[data-sm-reviews-progress]');
    const cards = () => [...track.children];
    const gap = () => parseFloat(getComputedStyle(track).columnGap) || 12.8;
    const step = () => { const c = cards()[0]; return c ? c.getBoundingClientRect().width + gap() : vp.clientWidth; };
    const atEnd = () => vp.scrollLeft + vp.clientWidth >= vp.scrollWidth - 2;
    const behavior = () => (reduce() ? 'auto' : 'smooth');

    // Active card = the one whose left edge is nearest the scroller's left edge; the last card once the end is reached.
    const indexNow = () => {
      const list = cards();
      if (!list.length) return 0;
      if (atEnd()) return list.length - 1;
      const left = vp.getBoundingClientRect().left;
      let best = 0, bestD = Infinity;
      list.forEach((c, i) => { const d = Math.abs(c.getBoundingClientRect().left - left); if (d < bestD) { bestD = d; best = i; } });
      return best;
    };
    const setArrow = (btn, off, other) => {
      if (!btn) return;
      const hadFocus = document.activeElement === btn;
      btn.classList.toggle('off', off);
      btn.disabled = off;
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
      if (off && hadFocus && other && !other.disabled) other.focus({ preventScroll: true });
    };
    const paint = () => {
      const n = cards().length || 1;
      const idx = indexNow();
      if (fill) fill.style.width = `${((idx + 1) / n * 100).toFixed(2)}%`;
      setArrow(prev, idx === 0, next);
      setArrow(next, idx === n - 1 || atEnd(), prev);
    };
    let raf = 0;
    const schedule = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; paint(); }); };
    vp.addEventListener('scroll', schedule, { passive: true });
    vp.addEventListener('scrollend', paint);
    window.addEventListener('resize', schedule, { passive: true });

    const by = (dir) => vp.scrollBy({ left: dir * step(), behavior: behavior() });
    if (prev) prev.addEventListener('click', () => by(-1));
    if (next) next.addEventListener('click', () => by(1));
    vp.addEventListener('keydown', (e) => {
      if (e.target !== vp) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); by(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); by(-1); }
    });

    // Mouse drag (desktop). Touch and pen use native scrolling. Snap is off while dragging and back on at release,
    // which settles on the next card in the drag direction (one card per drag, like the Swiper reference).
    let drag = null;
    let suppressClick = false;
    vp.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      drag = { id: e.pointerId, x: e.clientX, left: vp.scrollLeft, moved: false };
    });
    vp.addEventListener('pointermove', (e) => {
      if (!drag || e.pointerId !== drag.id) return;
      const dx = e.clientX - drag.x;
      if (!drag.moved) {
        if (Math.abs(dx) < 4) return;
        drag.moved = true;
        vp.classList.add('is-drag');
        try { vp.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      }
      e.preventDefault();
      vp.scrollLeft = drag.left - dx;
    });
    const endDrag = (e) => {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      const d = drag;
      drag = null;
      if (!d.moved) return;
      try { vp.releasePointerCapture(d.id); } catch (err) { /* ignore */ }
      suppressClick = true;
      setTimeout(() => { suppressClick = false; }, 0);
      const s = step();
      const start = Math.round(d.left / s);
      const delta = vp.scrollLeft - d.left;
      const target = Math.abs(delta) > 40 ? start + Math.sign(delta) : start;
      const max = Math.max(0, cards().length - 1);
      vp.classList.remove('is-drag');
      vp.scrollTo({ left: Math.max(0, Math.min(max, target)) * s, behavior: behavior() });
    };
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('lostpointercapture', endDrag);
    vp.addEventListener('click', (e) => { if (suppressClick) { e.preventDefault(); e.stopPropagation(); } }, true);
    vp.addEventListener('dragstart', (e) => e.preventDefault());

    // Theme editor: selecting a review block scrolls its card into view.
    root.addEventListener('shopify:block:select', (e) => {
      const card = e.target.closest && e.target.closest('.rc');
      if (card) vp.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'auto' });
    });

    paint();
  }

  const run = () => document.querySelectorAll('[data-sm-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
